
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";

@Component({
  name: 'RuleTabPanel',
  components: {

  }
})
export default class RuleTabPanel extends Vue {
  @Prop({ required: true })
  private headerText: string;
}
